/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsUserCheck: {
  name: 'user-check';
  data: string;
} = {
  name: 'user-check',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM6 7a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm4 8a5 5 0 0 0-5 5 1 1 0 1 1-2 0 7 7 0 1 1 14 0 1 1 0 1 1-2 0 5 5 0 0 0-5-5Zm10.707-9.707a1 1 0 0 0-1.414 0L18 6.586l-.293-.293a1 1 0 1 0-1.414 1.414l.293.293a2 2 0 0 0 2.828 0l1.293-1.293a1 1 0 0 0 0-1.414Z" fill="currentColor"/></svg>`,
};
